export enum PAGE_NAME_NEWS_TIPS_LIST {
  BERITA_DAN_TIPS_LISTING_PAGE = 'berita dan tips listing page',
}
